import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import axiosInstance from '../../api/axios';
import { API_ENDPOINTS } from '../../api/endpoints';
import { getApiErrorMessage, resolve403ErrorMessage } from '../../request/getApiErrorMessage.ts';

export function useExtractProcessesMutation() {
  return useMutation({
    mutationFn: async ({ cycle_id, cycle_name, documents }) => {
      const response = await axiosInstance.post(API_ENDPOINTS.extractProcesses, {
        cycle_id,
        cycle_name,
        documents
      });
      return response.data;
    },
    onError: (error) => {
      toast.error(resolve403ErrorMessage(error, getApiErrorMessage(error, 'Failed to extract processes')));
    }
  });
}
